import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import useAxios from 'api/useAxios'
import { AxiosError, AxiosInstance } from 'axios'
import diseaseMapping from './diseaseMapping'

export default function useIliAriSariData(
  extraProps?: UseQueryOptions<any, any>
) {
  const axios = useAxios()

  return useQuery<any[], AxiosError>(
    ['epidDashboard', 'iliAriSariData'],
    () => fetchData(axios),
    { ...extraProps }
  )
}

export const fetchData = async (axios: AxiosInstance): Promise<any[]> => {
  return axios('/lzdb/rid-datastream-ili-ari-sari/').then((response) =>
    response.data.map((x: any) => ({
      ...x,
      disease_name:
        x.disease_name in diseaseMapping
          ? diseaseMapping[x.disease_name as keyof typeof diseaseMapping]
          : x.disease_name,
    }))
  )
}
